import includes from 'lodash/includes';
import { REQUEST_CREATION_ORDER } from '../../common/constants.tsx';
import type { GetNextRequestAliasPayload, GetNextRequestAliasService } from './types.tsx';

const service: GetNextRequestAliasService = ({ createdAliases }: GetNextRequestAliasPayload) =>
	REQUEST_CREATION_ORDER.find((issueAlias) => !includes(createdAliases, issueAlias));

export default service;
